module.exports = __webpack_public_path__ + "static/media/dNTPs.c59b7774.svg";